import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/itemDepartments`;

export const ROUTE: RouteDefinition = `${baseRoute}/itemDepartments`;

export const URL = (): RouteDefinition => `${baseRoute}/itemDepartments`;
